import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../../constants/colors.js';
import { styles } from '../../constants/styles.js';
import { buttonThemeWeb, buttonThemeNative, buttonDarkThemeWeb, buttonDarkThemNative } from '../../Button/theme.js';
import { fortumLogoThemeWeb } from '../../FortumLogo/theme.js';
import { inputFieldThemeWeb, inputFieldThemeNative, inputFieldDarkThemeWeb, inputFieldDarkThemeNative } from '../../InputField/theme.js';
import { descriptionListThemeWeb, descriptionListDarkThemeWeb } from '../../DescriptionList/theme.js';
import { checkboxThemeNative, checkboxThemeWeb, checkboxDarkThemeWeb, checkboxDarkThemeNative } from '../../Checkbox/theme.js';
import { radioThemeNative, radioThemeWeb, radioDarkThemeNative, radioDarkThemeWeb } from '../../Radio/theme.js';
import { accordionThemeNative, accordionThemeWeb, accordionDarkThemeWeb, accordionDarkThemeNative } from '../../Accordion/theme.js';
import { selectThemeNative, selectThemeWeb, selectDarkThemeWeb, selectDarkThemeNative } from '../../Select/theme.js';
import { chipsThemeNative, chipsThemeWeb, chipsDarkThemeWeb, chipsDarkThemeNative } from '../../Chips/theme.js';
import { contentSwitcherThemeNative, contentSwitcherThemeWeb, contentSwitcherDarkThemeWeb } from '../../ContentSwitcher/theme.js';
import { dotsThemeNative, dotsThemeWeb, dotsDarkThemeWeb, dotsDarkThemeNative } from '../../Dots/theme.js';
import { errorMessageThemeNative, errorMessageThemeWeb } from '../../ErrorMessage/theme.js';
import { linkThemeWeb, linkThemeNative } from '../../Link/theme.js';
import { paginationThemeWeb, paginationThemeNative } from '../../Pagination/theme.js';
import { popoverThemeWeb } from '../../Popover/theme.js';
import { tableThemeWeb, tableDarkThemeWeb } from '../../Table/theme.js';
import { tabsThemeWeb, tabsThemeNative, tabsDarkThemeWeb } from '../../Tabs/theme.js';
import { textAreaThemeWeb } from '../../Textarea/theme.js';
import { toggleThemeWeb, toggleThemeNative, toggleDarkThemeNative, toggleDarkThemeWeb } from '../../Toggle/theme.js';
import { stepperThemeNative, stepperThemeWeb } from '../../Stepper/theme.js';
import 'styled-components';
import { sliderThemeNative, sliderThemeWeb, sliderDarkThemeNative } from '../../Slider/theme.js';
import { contextLinkThemeNative, contextLinkDarkThemeNative } from '../../ContextLink/theme.js';
import { headingThemeNative, headingThemeWeb } from '../../Heading/theme.js';
import { listItemsThemeWeb, listItemsDarkThemeWeb } from '../components/ListItems/theme.js';
import { linearProgressThemeWeb, linearProgressDarkThemeWeb } from '../../LinearProgress/theme.js';
import { circularProgressThemeWeb } from '../../CircularProgress/theme.js';
import { multiselectThemeWeb } from '../../Multiselect/theme.js';
import { npsThemeWeb } from '../../NPS/theme.js';
import { contentTextThemeWeb, contentTextThemeNative } from '../../ContentText/theme.js';
import { datepickerThemeWeb, datepickerDarkThemeWeb } from '../../DatePicker/theme.js';
import { placeholderThemeWeb, placeholderDarkThemeWeb } from '../../Placeholder/theme.js';
import { sectionThemeWeb, sectionDarkThemeWeb } from '../../Section/theme.js';
import { notificationThemeNative, notificationThemeWeb } from '../../Notification/theme.js';
import { searchThemeWeb, searchDarkThemeWeb } from '../../Search/theme.js';
import { fileUploadThemeWeb, fileUploadDarkThemeWeb } from '../../FileUpload/theme.js';

var defaultTheme = {
  variant: 'normal',
  preferredComponentSize: 'l',
  colors: {
    primary: colors.forestGreen,
    secondary: colors.cushyBlue,
    accent: colors.punchRed,
    alert: colors.hazeRedOrange,
    text: colors.inkGrey,
    background: colors.snowWhite
  },
  borders: {
    radius: undefined
  },
  font: {
    family: styles.fontFamily.base,
    fontMapNative: {
      regular: 'FortumSansTT-Regular',
      regularItalic: 'FortumSansTT-RegularItalic',
      light: 'FortumSansTT-Light',
      lightItalic: 'FortumSansTT-LightItalic',
      bold: 'FortumSansTT-Bold',
      boldItalic: 'FortumSansTT-BoldItalic',
      medium: 'FortumSansTT-Medium',
      mediumItalic: 'FortumSansTT-MediumItalic'
    },
    "native": {
      maxScaleFactor: 0
    }
  },
  accordion: {
    "native": accordionThemeNative,
    web: accordionThemeWeb
  },
  button: {
    web: buttonThemeWeb,
    "native": buttonThemeNative
  },
  chips: {
    "native": chipsThemeNative,
    web: chipsThemeWeb
  },
  circularProgress: {
    web: circularProgressThemeWeb,
    "native": null
  },
  checkbox: {
    "native": checkboxThemeNative,
    web: checkboxThemeWeb
  },
  contentSwitcher: {
    "native": contentSwitcherThemeNative,
    web: contentSwitcherThemeWeb
  },
  contentText: {
    web: contentTextThemeWeb,
    "native": contentTextThemeNative
  },
  contextLink: {
    web: null,
    "native": contextLinkThemeNative
  },
  datepicker: {
    "native": null,
    web: datepickerThemeWeb
  },
  descriptionList: {
    "native": null,
    web: descriptionListThemeWeb
  },
  dots: {
    "native": dotsThemeNative,
    web: dotsThemeWeb
  },
  errorMessage: {
    "native": errorMessageThemeNative,
    web: errorMessageThemeWeb
  },
  fileUpload: {
    "native": null,
    web: fileUploadThemeWeb
  },
  fortumLogo: {
    "native": null,
    web: fortumLogoThemeWeb
  },
  heading: {
    "native": headingThemeNative,
    web: headingThemeWeb
  },
  inputField: {
    web: inputFieldThemeWeb,
    "native": inputFieldThemeNative
  },
  linearProgress: {
    web: linearProgressThemeWeb,
    "native": null
  },
  link: {
    web: linkThemeWeb,
    "native": linkThemeNative
  },
  listItems: {
    web: listItemsThemeWeb,
    "native": null
  },
  multiselect: {
    "native": null,
    web: multiselectThemeWeb
  },
  notification: {
    "native": notificationThemeNative,
    web: notificationThemeWeb
  },
  nps: {
    "native": null,
    web: npsThemeWeb
  },
  pagination: {
    web: paginationThemeWeb,
    "native": paginationThemeNative
  },
  placeholder: {
    "native": null,
    web: placeholderThemeWeb
  },
  popover: {
    web: popoverThemeWeb,
    "native": null
  },
  radio: {
    "native": radioThemeNative,
    web: radioThemeWeb
  },
  search: {
    "native": null,
    web: searchThemeWeb
  },
  section: {
    "native": null,
    web: sectionThemeWeb
  },
  select: {
    "native": selectThemeNative,
    web: selectThemeWeb
  },
  slider: {
    "native": sliderThemeNative,
    web: sliderThemeWeb
  },
  stepper: {
    "native": stepperThemeNative,
    web: stepperThemeWeb
  },
  table: {
    "native": null,
    web: tableThemeWeb
  },
  tabs: {
    web: tabsThemeWeb,
    "native": tabsThemeNative
  },
  textarea: {
    web: textAreaThemeWeb,
    "native": null
  },
  toggle: {
    web: toggleThemeWeb,
    "native": toggleThemeNative
  }
};
var condensedTheme = _extends({}, defaultTheme, {
  preferredComponentSize: 's',
  variant: 'condensed'
});
var darkTheme = _extends({}, defaultTheme, {
  colors: {
    primary: colors.optimisticGreen,
    secondary: colors.waterBlue,
    accent: colors.powerRed,
    alert: colors.energeticRedOrange,
    text: colors.cloudGrey,
    background: colors.raisinGrey
  },
  accordion: {
    web: accordionDarkThemeWeb,
    "native": accordionDarkThemeNative
  },
  button: {
    web: buttonDarkThemeWeb,
    "native": buttonDarkThemNative
  },
  checkbox: {
    web: checkboxDarkThemeWeb,
    "native": checkboxDarkThemeNative
  },
  chips: {
    web: chipsDarkThemeWeb,
    "native": chipsDarkThemeNative
  },
  contentSwitcher: {
    web: contentSwitcherDarkThemeWeb,
    "native": contentSwitcherThemeNative
  },
  contextLink: {
    web: null,
    "native": contextLinkDarkThemeNative
  },
  datepicker: {
    "native": null,
    web: datepickerDarkThemeWeb
  },
  descriptionList: {
    web: descriptionListDarkThemeWeb,
    "native": null
  },
  dots: {
    web: dotsDarkThemeWeb,
    "native": dotsDarkThemeNative
  },
  fileUpload: {
    web: fileUploadDarkThemeWeb,
    "native": null
  },
  inputField: {
    web: inputFieldDarkThemeWeb,
    "native": inputFieldDarkThemeNative
  },
  linearProgress: {
    web: linearProgressDarkThemeWeb,
    "native": null
  },
  listItems: {
    web: listItemsDarkThemeWeb,
    "native": null
  },
  placeholder: {
    web: placeholderDarkThemeWeb,
    "native": null
  },
  radio: {
    "native": radioDarkThemeNative,
    web: radioDarkThemeWeb
  },
  search: {
    "native": null,
    web: searchDarkThemeWeb
  },
  section: {
    web: sectionDarkThemeWeb,
    "native": null
  },
  select: {
    web: selectDarkThemeWeb,
    "native": selectDarkThemeNative
  },
  toggle: {
    "native": toggleDarkThemeNative,
    web: toggleDarkThemeWeb
  },
  slider: {
    "native": sliderDarkThemeNative,
    web: sliderThemeWeb
  },
  table: {
    web: tableDarkThemeWeb,
    "native": null
  },
  tabs: {
    "native": tabsThemeNative,
    web: tabsDarkThemeWeb
  }
});
var darkCondensedTheme = _extends({}, darkTheme, {
  variant: 'condensed'
}); // this adds the theme type to all styled() components
// https://styled-components.com/docs/api#create-a-declarations-file

export { condensedTheme, darkCondensedTheme, darkTheme, defaultTheme };
